<template>
  <main data-app="true" :class="activityClass">
    <fonts-group :fonts="fonts"></fonts-group>
    <focus-loop>
      <div class="wrapper-activity-app__inner">
        <div class="wrapper-inner__content">
          <aria-live-region
            :message="message"
            :is-visible="false"
            id="aria-live-message"
          />
          <slot></slot>
        </div>
      </div>
    </focus-loop>
    <!-- <activity-drop-down :view-components="viewComponents" @on-select-component="onSelectComponent"></activity-drop-down> -->
  </main>
</template>

<script>
import { AriaLiveRegion } from '../../AriaLiveRegion';
import { FocusLoop } from '@vue-a11y/focus-loop';
import { FontsGroup } from '../../FontPreload';
// import ActivityDropDown from './ActivityDropDown.vue'

export default {
  name: 'Activity',
  components: {
    FontsGroup,
    AriaLiveRegion,
    FocusLoop,
    // ActivityDropDown
  },
  props: {
    message: {
      type: String,
      required: true,
    },
    bgColor: {
      type: String,
    },
    fonts: {
      type: Array,
      default: () => [],
    },
    // viewComponents: {
    //   type: Array,
    //   default: () => []
    // }
  },
  computed: {
    activityClass() {
      const classes = {
        'wrapper-activity-app': true,
      };

      classes[`bg-${this.bgColor}`] = !!this.bgColor;

      return {
        ...classes,
      };
    },
  },
  destroyed() {
    this.removeActivityResources();
    window.removeEventListener('resize', this.refreshScale);
  },
  mounted() {
    this.setActivityResources();
    this.refreshScale();
    window.addEventListener('resize', this.refreshScale);
  },
  updated() {
    this.focusFirstFocusableElement();
  },
  // methods: {
  //   onSelectComponent(obj) {
  //     this.$emit('on-select-component', {...obj})
  //   }
  // }
};
</script>

<style lang="stylus" scoped>
@import "../Styles/activity.styl";
</style>
